import { useEffect, useState } from "react";
import styles from "../styles/page.module.css";
import { Spin } from "antd";
import { useParams } from "react-router-dom";
import useSurvey from "../../surveys/hooks/useSurvey";
import StatisticHeader from "./StatisticHeader";
import StatisticsFilters from "./StatisticsFilters";
import StatisticsCharts from "./StatisticsCharts";

const SurveysStadisticsUI = () => {
  const { id } = useParams();
  const { surveyStatistic, getSurveyStatistics } = useSurvey();
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getSurveyStatisticsHandler({
      id_survey: Number(id),
      type: 1,
    });
  }, []);

  const getSurveyStatisticsHandler = async (params) => {
    setLoading(true);
    await getSurveyStatistics(params);
    setFilters(params);
    setLoading(false);
  };

  return (
    <main className={styles.statistics}>
      <StatisticHeader filters={filters} surveyStatistic={surveyStatistic} />
      <Spin spinning={loading}>
        <StatisticsFilters
          id={id}
          getSurveyStatistics={getSurveyStatisticsHandler}
        />
      </Spin>
      {surveyStatistic && (
        <StatisticsCharts surveyStatistic={surveyStatistic} />
      )}
    </main>
  );
};

export default SurveysStadisticsUI;
